import { render, staticRenderFns } from "./BundleDetail.vue?vue&type=template&id=440a9b7c&"
import script from "./BundleDetail.vue?vue&type=script&lang=js&"
export * from "./BundleDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports